<ng-template #template>
  <div class="container">
    <div class="row px-0 py-5" style="min-height: 800px">
      <div class="p-lg-0 col-lg-12">
        <div class="card h-100">
          <div class="card-body table-responsive-md">
            <h3 style="margin-bottom: 0; margin-top: 15px">
              <span>{{ texts?.teamMembers }}</span>
            </h3>

            <div class="container">
              <div class="row px-0">
                <div class="col sub-type">
                  <a
                    (click)="addMember()"
                    class="btn font-btn-small text-uppercase btn-primary"
                    [ngClass]="cssColor + '-inv'"
                    >{{ texts?.addMember }}</a
                  >
                  <a
                    (click)="lostPassword()"
                    class="btn font-btn-small text-uppercase btn-primary"
                    [ngClass]="cssColor + '-inv'"
                    >{{ texts?.lostPassword }}</a
                  >
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row px-0">
                <div
                  class="card col-md-3 col-sm-6 col-xs-12 text-center"
                  style="width: 18rem"
                  *ngFor="let member of members"
                >
                  <div
                    style="
                      height: 250px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      class="card-img-top"
                      src="/img/Unknown-person.gif"
                      *ngIf="!member.photoId"
                      alt="photo"
                      style="max-width: 200px; height: 200px; margin: 0 auto"
                    />
                    <img
                      class="card-img-top"
                      [src]="
                        '/api/download/blob/' + member.photoId.toString()
                          | authImage
                          | async
                      "
                      *ngIf="member.photoId"
                      alt="photo"
                      style="
                        max-width: 200px;
                        max-height: 200px;
                        width: auto;
                        margin: 0 auto;
                      "
                    />
                  </div>
                  <div class="card-body">
                    <p class="card-text">
                      {{ member.firstName }} {{ member.lastName }}
                    </p>
                    <a
                      class="btn font-btn-small text-uppercase btn-outline-secondary mr-2 my-2"
                      (click)="updateMember(member.subUserId)"
                      >{{ texts?.updateMember }}</a
                    >
                    <a
                      class="btn font-btn-small text-uppercase btn-outline-secondary mr-2 my-2"
                      (click)="removeMember(member.subUserId)"
                      >{{ texts?.removeMember }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
